export const ShowcaseItem = ({ imgPath }: { imgPath: string }) => {
  return <img className="showcase-img" alt="Meta Ninja" src={imgPath} />;
};
